<p>Environment
  <select [(ngModel)]="env" (ngModelChange)="refreshEnv()">
    <option>CD</option>
    <option>DEV</option>
    <option>QA</option>
    <option>PROD</option>
    <option>TRAINING</option>
    <option>RESTORE</option>
  </select>
  <button type="button" class="btn-sm btn btn-primary" (click)="refreshEnv()">Refresh</button>
</p>

<p>selected env: {{env}}</p>

<h3>Tenants</h3>

@if (tenants.length) {
  <table class="table table-sm table-hover">
    <thead>
      <tr>
        <th>ID</th>
        <th>Name</th>
        <th>ReadableVersion</th>
        <th>TenantGroup</th>
        <th>accessible</th>
        <th>maintenance</th>
        <th>timezone</th>
      </tr>
    </thead>
    <tbody>
      @for (tenant of tenants; track tenant.id) {
        <tr (click)="displayTenantDetails(tenant.id, tenantDetails)">
          <td>{{tenant.id}}</td>
          <td>{{tenant.name}}</td>
          <td>{{tenant.readableVersion}}</td>
          <td>{{tenant.tenantGroup.matchCode}}</td>
          <td>{{tenant.accessible}}</td>
          <td>{{tenant.maintenance}}</td>
          <td>{{tenant.timezone}}</td>
        </tr>
      }
    </tbody>
  </table>
}

<h3 #tenantDetails>Tenant Details ({{tenantIdDetails}})</h3>

@if (applicationConfigurationsForTenant.length) {
  <table class="table table-sm table-hover">
    <thead>
      <tr>
        <th>ID</th>
        <th>name</th>
        <th>displayName</th>
        <th>externalUrl</th>
        <th>internalUrl</th>
        <th>commitId</th>
        <th>buildTimestamp</th>
        <th>readableVersion</th>
        <th>releaseVersion</th>
        <th>technicalVersion</th>
        <th>database</th>
      </tr>
    </thead>
    <tbody>
      @for (applicationConfigration of applicationConfigurationsForTenant; track applicationConfigration.id) {
        <tr>
          <td>{{applicationConfigration.id}}</td>
          <td>{{applicationConfigration.name}}</td>
          <td>{{applicationConfigration.displayName}}</td>
          <td>{{applicationConfigration.externalUrl}}</td>
          <td>{{applicationConfigration.internalUrl}}</td>
          <td>{{applicationConfigration.commitId}}</td>
          <td>{{applicationConfigration.buildTimestamp}}</td>
          <td>{{applicationConfigration.readableVersion}}</td>
          <td>{{applicationConfigration.releaseVersion}}</td>
          <td>{{applicationConfigration.technicalVersion}}</td>
          <td>
            <button type="button" (click)="getDb(applicationConfigration,content)">DB mgmt</button>
            <button type="button" (click)="getDbCountry(applicationConfigration,content)">DB country</button>
          </td>
        </tr>
      }
    </tbody>
  </table>
}


<h3>Application Groups</h3>

<ul>
  @for (applicationGroup of applicationGroups; track applicationGroup.id) {
    <li>
      <strong>{{applicationGroup.name}} ({{applicationGroup.id}}): </strong>
      @for (application of applicationGroup.applications; track application) {
        <span>{{application}} </span>
      }
    </li>
  }
</ul>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Database Details</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table table-sm table-hover">
      <thead>
        <tr>
          <th>Key</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>URL</td>
          <td>{{minimalDatabaseConnection.connectionString}}</td>
        </tr>
        <tr>
          <td>dbmsType</td>
          <td>{{minimalDatabaseConnection.dbmsType}}</td>
        </tr>
        <tr>
          <td>id</td>
          <td>{{minimalDatabaseConnection.id}}</td>
        </tr>
        <tr>
          <td>schema user</td>
          <td>{{minimalDatabaseConnection.user.username}}</td>
        </tr>
        <tr>
          <td>schema user password</td>
          <td>{{minimalDatabaseConnection.user.password}}</td>
        </tr>
        <tr>
          <td>application user</td>
          <td>{{minimalDatabaseConnection.user.applicationUsername}}</td>
        </tr>
        <tr>
          <td>application user password</td>
          <td>{{minimalDatabaseConnection.user.applicationPassword}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Ok click')">OK</button>
  </div>
</ng-template>
